<template>
    <div class="footer__contacts">
        <div :class="['fc__phones', {'fc__phones-shown': isItemsShow}]">
            <button
                v-show="!isItemsShow"
                :class="['fc__phones-additions', {'fc__phones-additions-shown': isItemsShow}]"
                @click="isItemsShow = true"
            >
                ДОПОЛНИТЕЛЬНЫЕ НОМЕРА
            </button>
            <ul>
                <li
                    v-for="(item) in phones"
                    :key="item.phone"
                    class="fc__phone"
                >
                    <p class="fc__phone__title">
                        {{ item.title }}
                    </p>
                    <a
                        :href="`tel:${item.phone.replace(/\s/g, '')}`"
                        class="fc__phone__number"
                        target="_blank"
                    >
                        {{ item.phone }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {defineComponent, ref} from 'vue';

import {footerPhones} from '@/core/models/common/FooterModel';

export default defineComponent({
    name: 'FooterContacts',
    setup() {
        const isItemsShow = ref(false);

        return {
            phones: footerPhones,
            isItemsShow,
        };
    },
});
</script>

<style lang="scss" scoped>
@import '@/assets/styles/common/footer/footer-contacts';
</style>
